import styles from "./TraitMobileFilter.module.css";

import SquareCheckbox from "@/components/shared/inputs/SquareCheckbox";
import TranslucentXMark from "@/components/shared/translucentXMark/TranslucentXMark";

type TraitsMobileFilterProps = {
  traitTypeDefault?: string;
  setTraitType: (trait: string) => void;
  removeTraitType: (trait: string) => void;
  setDimension: (dimension: string) => void;
  removeDimension: (dimension: string) => void;
  setNature: (nature: string) => void;
  removeNature: (nature: string) => void;
  setArchetype: (archetype: string) => void;
  removeArchetype: (archetype: string) => void;
  closeModal: (value: boolean) => void;
  display: boolean;
  traitType: string[];
  dimension: string[];
  nature: string[];
  archetypeType: string[];
  defualtSelected: "element" | "pattern" | "archetype";
};

export default function TraitMobileFilter(props: TraitsMobileFilterProps) {
  return (
    <div
      className={`${styles.main} ${
        props.display === true ? styles.display : false
      }`}
    >
      <div
        className={styles.closeButton}
        onClick={() => {
          props.closeModal(false);
        }}
      >
        <TranslucentXMark />
      </div>
      <div className={styles.leftBar}>
        <div className={styles.headingParent}>
          <h3 className={styles.filterHeading}>Trait Type</h3>
          <div className={styles.checkParent}>
            <SquareCheckbox
              defaultTrue={props.defualtSelected === "element" && true}
              setValue={(e) => {
                e === true && props.setTraitType("element");
                e === false && props.removeTraitType("element");
              }}
              currentValue={props.traitType.includes("element") ? true : false}
            />
            <h4>Elements</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              defaultTrue={props.defualtSelected === "pattern" && true}
              setValue={(e) => {
                e === true && props.setTraitType("pattern");
                e === false && props.removeTraitType("pattern");
              }}
              currentValue={props.traitType.includes("pattern") ? true : false}
            />
            <h4>Patterns</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              defaultTrue={props.defualtSelected === "archetype" && true}
              setValue={(e) => {
                e === true && props.setTraitType("archetype");
                e === false && props.removeTraitType("archetype");
              }}
              currentValue={
                props.traitType.includes("archetype") ? true : false
              }
            />
            <h4>Archetypes</h4>
          </div>
        </div>
        <div className={styles.headingParent}>
          <h3 className={styles.filterHeading}>Dimension</h3>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("personality-II");
                e === false && props.removeDimension("personality-II");
              }}
              currentValue={
                props.dimension.includes("personality-II") ? true : false
              }
            />
            <h4>Cognition</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("personality");
                e === false && props.removeDimension("personality");
              }}
              currentValue={
                props.dimension.includes("personality") ? true : false
              }
            />
            <h4>Primary Traits</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("values");
                e === false && props.removeDimension("values");
              }}
              currentValue={props.dimension.includes("values") ? true : false}
            />
            <h4>Values</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("communication-style");
                e === false && props.removeDimension("communication-style");
              }}
              currentValue={
                props.dimension.includes("communication-style") ? true : false
              }
            />
            <h4>Interaction Styles</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("interests");
                e === false && props.removeDimension("interests");
              }}
              currentValue={
                props.dimension.includes("interests") ? true : false
              }
            />
            <h4>Interests</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("attachment-style");
                e === false && props.removeDimension("attachment-style");
              }}
              currentValue={
                props.dimension.includes("attachment-style") ? true : false
              }
            />
            <h4>Attachment Styles</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("love-style");
                e === false && props.removeDimension("love-style");
              }}
              currentValue={
                props.dimension.includes("love-style") ? true : false
              }
            />
            <h4>Love Styles</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("love-attitudes");
                e === false && props.removeDimension("love-attitudes");
              }}
              currentValue={
                props.dimension.includes("love-attitudes") ? true : false
              }
            />
            <h4>Love Attitudes</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("conflict-style");
                e === false && props.removeDimension("conflict-style");
              }}
              currentValue={
                props.dimension.includes("conflict-style") ? true : false
              }
            />
            <h4>Conflict Styles</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setDimension("strengths");
                e === false && props.removeDimension("strengths");
              }}
              currentValue={
                props.dimension.includes("strengths") ? true : false
              }
            />
            <h4>Strengths</h4>
          </div>
        </div>

        <div className={styles.headingParent}>
          <h3 className={styles.filterHeading}>Nature</h3>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("selfEnhancement");
                e === false && props.removeNature("selfEnhancement");
              }}
              currentValue={
                props.nature.includes("selfEnhancement") ? true : false
              }
            />
            <h4>Passion & Sensitivity</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("opennessAndIntellect");
                e === false && props.removeNature("opennessAndIntellect");
              }}
              currentValue={
                props.nature.includes("opennessAndIntellect") ? true : false
              }
            />
            <h4>Openness & Curiosity</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("warmthAndAgreeableness");
                e === false && props.removeNature("warmthAndAgreeableness");
              }}
              currentValue={
                props.nature.includes("warmthAndAgreeableness") ? true : false
              }
            />
            <h4>Warmth & Agreeableness</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("orderAndStructure");
                e === false && props.removeNature("orderAndStructure");
              }}
              currentValue={
                props.nature.includes("orderAndStructure") ? true : false
              }
            />
            <h4>Order & Responsibility</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("tranquility");
                e === false && props.removeNature("tranquility");
              }}
              currentValue={props.nature.includes("tranquility") ? true : false}
            />
            <h4>Tranquility</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("energyAndExcitement");
                e === false && props.removeNature("energyAndExcitement");
              }}
              currentValue={
                props.nature.includes("energyAndExcitement") ? true : false
              }
            />
            <h4>Energy & Excitement</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setNature("selfEnhancement");
                e === false && props.removeNature("selfEnhancement");
              }}
              currentValue={
                props.nature.includes("selfEnhancement") ? true : false
              }
            />
            <h4>Ambition & Self-Enhancement</h4>
          </div>
        </div>

        <div className={styles.headingParent}>
          <h3 className={styles.filterHeading}>Archetype Type</h3>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("identity");
                e === false && props.removeArchetype("identity");
              }}
              currentValue={
                props.archetypeType.includes("identity") ? true : false
              }
            />
            <h4>Identity</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("love");
                e === false && props.removeArchetype("love");
              }}
              currentValue={props.archetypeType.includes("love") ? true : false}
            />
            <h4>Love</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("work");
                e === false && props.removeArchetype("work");
              }}
              currentValue={props.archetypeType.includes("work") ? true : false}
            />
            <h4>Work</h4>
          </div>
          <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("career");
                e === false && props.removeArchetype("career");
              }}
              currentValue={
                props.archetypeType.includes("career") ? true : false
              }
            />
            <h4>Career</h4>
          </div>
          {/* <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("spirit");
                e === false && props.removeArchetype("spirit");
              }}
              currentValue={
                props.archetypeType.includes("spirit") ? true : false
              }
            />
            <h4>Spirit</h4>
          </div> */}
          {/* <div className={styles.checkParent}>
            <SquareCheckbox
              setValue={(e) => {
                e === true && props.setArchetype("values");
                e === false && props.removeArchetype("values");
              }}
              currentValue={
                props.archetypeType.includes("values") ? true : false
              }
            />
            <h4>Values</h4>
          </div> */}
        </div>
      </div>
    </div>
  );
}
